// src/pages/HealthRecord/Summary.tsx

import React from "react";

interface SummaryData {
  id: number;
  final_at: string;
  healthcare: string;
  doctor: string;
  speciality: string;
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;
  date: string;
}

interface SummaryProps {
  summary: SummaryData;
}

const Summary: React.FC<SummaryProps> = ({ summary }) => {
    const formatFullDateTime = (dateTimeString: string) => {
        const date = new Date(dateTimeString.replace(' ', 'T'));
      
        const formattedDate = new Intl.DateTimeFormat('id-ID', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        }).format(date);
      
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        const formattedTime = `${hours}:${minutes}:${seconds}`;
      
        return `${formattedDate} ${formattedTime}`;
    };      
      
  return (
    <div className="mb-3">
        <div className="p-0 overflow-hidden bg-white border border-pink-300 rounded-md shadow-md">
            <div className="absolute -left-6 top-4 w-4 h-4 bg-white rounded-full border border-green-300 z-10" />
            <div className="p-3 bg-white">
                <h2 className="text-base font-bold text-pink-600 md:text-lg">
                    Consultation Summary
                </h2>
            </div>
            <hr className="border-pink-200" />
            <div className="flex flex-wrap px-4 py-2 text-sm md:text-base">
                <div className="w-1/2 md:w-1/3 font-semibold">Healthcare</div>
                <div className="w-1/2 md:w-2/3">: {summary.healthcare}</div>

                <div className="w-1/2 md:w-1/3 font-semibold">Doctor</div>
                <div className="w-1/2 md:w-2/3">: {summary.doctor}</div>

                <div className="w-1/2 md:w-1/3 font-semibold">Speciality</div>
                <div className="w-1/2 md:w-2/3">: {summary.speciality}</div>

                <div className="w-1/2 md:w-1/3 font-semibold">Date</div>
                <div className="w-1/2 md:w-1/3">: {formatFullDateTime(summary.date)}</div>
            </div>

            <hr className="border-pink-200" />
            <div className="px-4 py-2 text-sm md:text-base">
                <div className="mb-3">
                    <p className="font-semibold">Subjective</p>
                    <p>{summary.subjective}</p>
                </div>
                <div className="mb-3">
                    <p className="font-semibold">Objective</p>
                    <p>{summary.objective}</p>
                </div>
                <div className="mb-3">
                    <p className="font-semibold">Assesment</p>
                    <p>{summary.assessment}</p>
                </div>
                <div className="mb-3">
                    <p className="font-semibold">Plan</p>
                    <p>{summary.plan}</p>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Summary;
